import React from "react";
export const OpenSideBar = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="12"
        cy="12"
        r="11.5"
        fill="white"
        stroke="url(#paint0_linear_2036_90664)"
      />
      <path
        d="M14.7908 12.0037L11.112 8.19918C11.0515 8.13607 10.9796 8.08597 10.9004 8.05179C10.8212 8.0176 10.7363 8 10.6505 8C10.5647 8 10.4797 8.0176 10.4005 8.05179C10.3213 8.08597 10.2494 8.13607 10.189 8.19918C10.0679 8.32534 10 8.49601 10 8.6739C10 8.85179 10.0679 9.02245 10.189 9.14862L13.4063 12.5154L10.189 15.8486C10.0679 15.9747 10 16.1454 10 16.3233C10 16.5012 10.0679 16.6718 10.189 16.798C10.2492 16.8616 10.321 16.9122 10.4002 16.9469C10.4794 16.9816 10.5645 16.9996 10.6505 17C10.7365 16.9996 10.8215 16.9816 10.9008 16.9469C10.98 16.9122 11.0518 16.8616 11.112 16.798L14.7908 12.9935C14.8567 12.9305 14.9094 12.8539 14.9454 12.7687C14.9814 12.6836 15 12.5916 15 12.4986C15 12.4056 14.9814 12.3136 14.9454 12.2284C14.9094 12.1432 14.8567 12.0667 14.7908 12.0037Z"
        fill="url(#paint1_linear_2036_90664)"
        stroke="url(#paint2_linear_2036_90664)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2036_90664"
          x1="1.08965e-07"
          y1="12"
          x2="24"
          y2="12"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#775FD5" />
          <stop offset="1" stop-color="#F03A85" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_2036_90664"
          x1="10"
          y1="12.5"
          x2="15"
          y2="12.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#775FD5" />
          <stop offset="1" stop-color="#F03A85" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_2036_90664"
          x1="10"
          y1="12.5"
          x2="15"
          y2="12.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#775FD5" />
          <stop offset="1" stop-color="#F03A85" />
        </linearGradient>
      </defs>
    </svg>
  );
};
